import {
  Box,
  Container,
  Divider,
  emphasize,
  Paper,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const DetailContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
}));

export const DetailTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  display: "flex",
  whiteSpace: "nowrap",
  "& > span:last-child": {
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  "& > span:not(:last-child)::after": {
    content: '" | "',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
}));

export const StatusBox = styled(Paper)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(4),
  marginBottom: theme.spacing(3),
  "& hr": {
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(4),
  },
}));

export const StateSection = styled("div")(({ theme }) => ({
  minWidth: theme.spacing(56),
  display: "flex",
  alignItems: "center",
}));

export const StyledStateIcon = styled("div")(({ theme }) => ({
  display: "flex",
  fontSize: theme.spacing(9),
  marginRight: theme.spacing(4),
}));

export const StateDescription = styled("div")(({ theme }) => ({
  "& > *:not(:last-child)": {
    paddingBottom: theme.spacing(1),
  },
}));

export const StateInfoAndActionSection = styled("div")({
  flexGrow: 1,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const StateActionWrapper = styled("div")<{
  hasAdjacentNote?: boolean;
}>(({ theme, hasAdjacentNote }) => ({
  ...(hasAdjacentNote && {
    paddingLeft: theme.spacing(1),
    "& button": {
      "& span": {
        justifyContent: "flex-start",
      },
    },
  }),
}));

export const TableHeadRow = styled(TableRow)(() => ({
  backgroundColor: "inherit",
  "&:last-child .MuiTableCell-root": {
    border: "none",
  },
}));

export const StatusBoxDivider = () => (
  <Divider orientation="vertical" flexItem />
);

export const ErrorPopoverContent = styled(Box)(({ theme }) => {
  const emphasis = theme.palette.mode === "light" ? 0.8 : 0.98;
  const backgroundColor = emphasize(theme.palette.background.default, emphasis);

  return {
    display: "flex",
    alignItems: "center",
    backgroundColor: backgroundColor,
    padding: "6px 6px 6px 16px",
    "& .error-label": {
      marginRight: theme.spacing(1),
      color: theme.palette.getContrastText(backgroundColor),
    },
    "& .error-message": {
      marginRight: theme.spacing(1),
      color: theme.palette.getContrastText(backgroundColor),
    },
    "& .close-button": {
      marginLeft: theme.spacing(1),
      color: theme.palette.getContrastText(backgroundColor),
    },
  };
});
